<template>
    <div class="general">
        <div class="testStudent-body collection testStudent-body-mobile collection-mobile">
            <h2>Назначение лабораторных исследований</h2>
            <div class="diagnosis-body">
                <div class="diagnosis-left" >
                    <h3>Выберите группу исследования:</h3>

                    <v-autocomplete
                        class="combobxComp"
                        :full-width="true"
                        v-model="select"
                        :items="getLabTest.group"
                        item-text="groupName"
                        @change="changeGroup(select)"
                        return-object
                        label=""
                        outlined
                        dense
                    />

                    <div class="item-instrumental" v-if="select && select.properties && select.properties.length > 0">
                        <p class="instrumental-txt">Выберите исследование:</p>

                        <v-checkbox
                            @click="selectAllProperties(selectAllFlag, select)"
                            v-model="selectAllFlag"
                            :ripple="false"
                            color="#4854FE"
                            :label="selectAllFlag ? 'Скрыть все' : 'Выбрать все'"
                        />

                        <div class="list" v-for="(el, ind) in select.properties" :key="'d'+ind">
                            <v-checkbox
                                :ripple="false"
                                v-model="el.isSelected"
                                :disabled="el.isSelected"
                                :label="el.propertyName"
                                @click="addProperty(el)"
                            />
                        </div>
                    </div>
                </div>
                <div class="diagnosis-left right">
                    <h3>Выбранные исследования</h3>

                    <SelectedResearches
                        :takeOrder="getGeneral.virtualPatient.isLabTakeOrder"
                        :loadingSelected="loadingSelected"
                        :selectedArray="selectedArray"
                        :selected="selected"
                        @drag="dragResearch"
                        @confirmDelete="openDelete"
                    />

                </div>
            </div>

        </div>

        <div class="button d-flex justify-end mt-8">
            <div class="btn-mobile">
                <v-bottom-sheet v-model="sheet" inset>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="btn-left mb-3" v-bind="attrs" v-on="on">Выбранные исследования</v-btn>
                    </template>
                    <v-sheet class="pt-1">
                        <div
                            @click="sheet = !sheet"
                            style="margin: 10px auto 0 auto; width: 43px; height: 6px; background:#D9D9D9; border-radius: 20px"
                            v-touch="{ down: () => sheet = false }"
                        />
                        <div class="sheet-container">
                            <h3 class="px-2">Выбранные исследования</h3>

                            <SelectedResearches
                                :takeOrder="getGeneral.virtualPatient.isLabTakeOrder"
                                :loadingSelected="loadingSelected"
                                :selectedArray="selectedArray"
                                :selected="selected"
                                @drag="dragResearch"
                                @confirmDelete="openDelete"
                            />
                        </div>
                    </v-sheet>
                </v-bottom-sheet>
            </div>

            <v-btn class="btn-left mb-3" :loading="loadingGetResultResearch" @click.prevent="getResultResearch">Получить результаты исследований</v-btn>
            <slot name="btn" />
        </div>

        <v-dialog v-model="showDelete" persistent max-width="452" >
            <v-card>
                <v-card-title class="text-h5">
                    Удаление исследования
                </v-card-title>
                
                <v-card-text>
                    Уважаемый студент, вы действительно хотите удалить исследование?
                </v-card-text>
                
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn class="v-btn-custom" :disabled="deleteLoading" @click="close">Отменить</v-btn>

                    <v-btn class="v-btn-custom" :loading="deleteLoading" @click="deleteResearch(selectedObj.it, selectedObj.ind, selectedObj.item)">Удалить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        

        <!-- <v-dialog v-model="showDelete" max-width="452" persistent>
            <div class="media-container">
                <div class="containerShadowN">
                    <v-btn class="bodySystems-close" :disabled="deleteLoading" @click.prevent="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                            <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </v-btn>
                    <div class="deletEl">
                        <h2>Удаление исследования</h2>
                        <div class="text-container">
                            <p>Уважаемый студент, вы действительно хотите удалить исследование?</p>
                        </div>
                        <div class="btn-container">
                            <v-btn :disabled="deleteLoading" @click="close">Отменить</v-btn>
                            <v-btn :loading="deleteLoading" @click="deleteResearch(selectedObj.it, selectedObj.ind, selectedObj.item)">Удалить</v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </v-dialog> -->

        <v-dialog v-if="showResearch" v-model="showResearch" max-width="700" >
            <div class="media-container">
                <div class="containerShadowN containerShadowN-mobile ">
                    <v-btn class="bodySystems-close" @click.prevent="showResearch = false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                            <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </v-btn>
                    <div class="deletEl research-container">
                        <div class="d-flex align-center">
                            <h2>Результаты исследований</h2>
                            <div class="ml-2 pt-1">
                                <v-tooltip top content-class="custom-tooltip">
                                    <template v-slot:activator="{ on, attrs }">
                                        <svg v-bind="attrs" v-on="on" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                            <rect y="0.5" width="24" height="24" rx="12" fill="#CACDD3"/>
                                            <path d="M10.873 14.9972V14.8892C10.8806 14.1847 10.9507 13.6241 11.0833 13.2074C11.2196 12.7908 11.4128 12.4536 11.6628 12.1961C11.9128 11.9385 12.214 11.7036 12.5662 11.4915C12.7935 11.3476 12.998 11.1866 13.1799 11.0086C13.3617 10.8305 13.5056 10.626 13.6117 10.3949C13.7177 10.1639 13.7708 9.90819 13.7708 9.62789C13.7708 9.29076 13.6912 8.9991 13.5321 8.75289C13.373 8.50667 13.1609 8.31728 12.8958 8.1847C12.6344 8.04834 12.3427 7.98016 12.0208 7.98016C11.7291 7.98016 11.4507 8.04076 11.1855 8.16198C10.9204 8.28319 10.7007 8.47258 10.5265 8.73016C10.3522 8.98395 10.2518 9.3116 10.2253 9.71311H8.49805C8.52456 9.03129 8.69691 8.45554 9.01509 7.98584C9.33327 7.51236 9.75373 7.1544 10.2765 6.91198C10.803 6.66955 11.3844 6.54834 12.0208 6.54834C12.7177 6.54834 13.3276 6.67902 13.8503 6.94039C14.373 7.19796 14.7784 7.5597 15.0662 8.02561C15.3579 8.48773 15.5037 9.02751 15.5037 9.64493C15.5037 10.0692 15.4374 10.4517 15.3049 10.7927C15.1723 11.1298 14.9829 11.4309 14.7367 11.6961C14.4943 11.9612 14.2026 12.1961 13.8617 12.4006C13.5397 12.6014 13.2783 12.8097 13.0776 13.0256C12.8806 13.2415 12.7367 13.4972 12.6458 13.7927C12.5549 14.0881 12.5056 14.4536 12.498 14.8892V14.9972H10.873ZM11.731 18.4517C11.4204 18.4517 11.1533 18.3419 10.9299 18.1222C10.7064 17.8987 10.5946 17.6298 10.5946 17.3154C10.5946 17.0048 10.7064 16.7396 10.9299 16.5199C11.1533 16.2964 11.4204 16.1847 11.731 16.1847C12.0378 16.1847 12.303 16.2964 12.5265 16.5199C12.7537 16.7396 12.8674 17.0048 12.8674 17.3154C12.8674 17.5237 12.8143 17.715 12.7083 17.8892C12.606 18.0597 12.4696 18.1961 12.2992 18.2983C12.1287 18.4006 11.9393 18.4517 11.731 18.4517Z" fill="white"/>
                                        </svg>
                                    </template>
                                    <div class="info-tooltip">Отметьте патологию <br> одиночным кликом по <br> тексту </div>
                                </v-tooltip>
                            </div>
                        </div>
                        <div class="result-container">
                            <h3>Лабораторные исследования</h3>
                            <div class="research-result">
                                <div class="overflow">
                                    <div
                                        v-show="resultResearchList"
                                        v-for="(it, inx) in resultResearchList"
                                        :key="'k'+inx"
                                        class="result-tem"
                                    >
                                        <h4>{{ inx }}</h4>
                                        <div
                                            v-for="(el, ind) in it"
                                            class="d-flex flex-column result-tem"
                                            :class="{ 'choose': el.isPathology }"
                                            @click="selectedPatalogy(el)"
                                            :key="'l'+ind"
                                        >
                                            <span v-if="el.valueType === 1">
                                                {{ el.propertyName }}: {{ el.listValueName }}
                                            </span>
                                            <span v-if="el.valueType === 0">
                                                {{ el.propertyName }}: {{ el.avgValue }} {{ el.measurementName }}
                                            </span>
                                        </div>
                                    </div>
                                    <div v-if="!resultResearchList" class="result-tem">
                                        Лабораторные исследования не проводились.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btn-container research-btn-container">
                            <v-btn @click="showResearch = false">Закрыть</v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import SelectedResearches from '../Shared/SelectedResearches/index.vue';

export default {
    name: 'LaboratoryTests',
    components: { SelectedResearches },
    computed: {
        ...mapGetters({
            getGeneral: 'takeDiagnosticTest/getGeneral',
            getLabTest: 'takeDiagnosticTest/getLabTest',
            getFirstStepOrNot: 'takeDiagnosticTest/getFirstStepOrNot'
        }),
        isSelectedAll() {
            return this.select.properties.every((f)=> f.isSelected )
        }
    },
    data() {
        return {
            loadingSelected: true,
            loadingGetResultResearch: false,
            deleteLoading: false,
            showDelete: false,
            selectAllFlag: false,
            showResearch: false,
            select: {
                properties: []
            },
            sheet: false,
            selected: null,
            selectedArray: [],
            resultResearchList: null
        }
    },
    methods: {
        ...mapActions({
            getSections: 'takeDiagnosticTest/getSections',
            getLabResearchesForProcess: 'takeDiagnosticTest/getLabResearchesForProcess',
            addOrUpdateLabResearchAnswer: 'takeDiagnosticTest/addOrUpdateLabResearchAnswer',
            getLabResearchAnswer: 'takeDiagnosticTest/getLabResearchAnswer',
            deleteLabResearchAnswer: 'takeDiagnosticTest/deleteLabResearchAnswer',
            getResultForResearch: 'takeDiagnosticTest/getResultForResearch',
            sendLabResearchPathologyAnswer: 'takeDiagnosticTest/sendLabResearchPathologyAnswer'
        }),
        ...mapMutations({
            changeViewPage: 'takeDiagnosticTest/changeViewPage',
            checkingFirstStep: 'takeDiagnosticTest/checkingFirstStep'
        }),
        openDelete(it, ind, item) {
            this.selectedObj = { it, ind, item };
            this.showDelete = true;
        },
        changeGroup(select){
            if (select === null) {
                this.select =  this.select = { properties: [] }
                this.selected = null;
            }

            if(select.isSelected) this.selectAllFlag = true;
            else this.selectAllFlag = false;
        },
        selectAllProperties(selectAllFlag, select){
            let array = [];
            select.isSelected = selectAllFlag;

            // Если нужно скрыть все
            if(!selectAllFlag) {
                for (let i = 0; i < this.selectedArray.length; i++) {
                    for (let j = 0; j < select.properties.length; j++) {
                        select.properties[j].isSelected = selectAllFlag;

                        if(this.selectedArray[i].answerGroupId === select.properties[j].groupId && this.selectedArray[i].answerPropertyId === select.properties[j].propertyId) {
                            select.properties[j].answerId = this.selectedArray[i].id;
                        }
                    }
                }
                array = select.properties;
                this.selected = null;
                this.selectedArray = [];
                                
                this.loadingSelected = true;
                this.deleteLabResearchAnswer(array.map((m) => m.answerId))
                    .then(() => {
                        this.getSelectedLabResearch();
                    })

                return;
            }

            let propertiesFilter = select.properties.filter((f) => !f.isSelected);

            for (let i = 0; i < propertiesFilter.length; i++) {
                propertiesFilter[i].isSelected = selectAllFlag;

                array.push({
                    processId: this.$route.params.id,
                    answerGroupId: select.groupId,
                    answerGroupName: select.groupName,
                    answerPropertyId: propertiesFilter[i].propertyId,
                    answerPropertyName: propertiesFilter[i].propertyName
                })
            }
            
            this.selected = null;
            this.selectedArray = [];
            this.loadingSelected = true;
            this.addOrUpdateLabResearchAnswer(array)
                .then(() => {
                    this.getSelectedLabResearch();
                })
        },
        addProperty(item) {
            item.isSelected = true;
            this.selectAllFlag = this.isSelectedAll

            this.selected = null;
            this.loadingSelected = true;
            this.addOrUpdateLabResearchAnswer([
                {
                    processId: this.$route.params.id,
                    answerGroupId: this.select.groupId,
                    answerPropertyId: item.propertyId,
                    answerGroupName: this.select.groupName,
                    answerPropertyName: item.propertyName
                }
            ])
            .then((res) => {
                this.getSelectedLabResearch();
            })
        },
        dragResearch(event, list) {
            let beginIndex, endIndex;
            let updated = [];

            if (event.moved.oldIndex > event.moved.newIndex) {
                beginIndex = event.moved.newIndex;
                endIndex = event.moved.oldIndex;
            } else {
                beginIndex = event.moved.oldIndex;
                endIndex = event.moved.newIndex;
            }

            for (let i = beginIndex; i <= endIndex; i++) {
                list[i].ord = i + 1;
                updated.push(list[i]);
            }

            this.addOrUpdateLabResearchAnswer(updated);
        },
        deleteResearch(it, ind, item) {
            this.deleteLoading = true;
            
            this.deleteLabResearchAnswer(it)
                .then(() => {
                    item.splice(ind, 1);
                    this.deleteLoading = false;
                    this.selectAllFlag = false;
                    this.close();
                })
        },
        close() {
            this.selectedObj = null;
            this.showDelete = false;
        },
        getResultResearch() {
            let url = 'DiaTestProcess/GetLabResearchPathologyAnswers';
            this.loadingGetResultResearch = true;

            this.getResultForResearch({ url, processId: this.$route.params.id })
                .then((res) => {
                    this.resultResearchList = Object.groupBy(res, ({ groupName }) => groupName);
                    this.loadingGetResultResearch = false;
                    this.showResearch = true;
                })
        },
        selectedPatalogy(item) {
            item.isPathology = !item.isPathology

            this.sendLabResearchPathologyAnswer({ processId: this.$route.params.id, answerPropertyId: item.id, isPathology: item.isPathology });

        },
        getSelectedLabResearch() {
            this.getLabResearchAnswer(this.$route.params.id)
                .then((res) => {
                    this.selected = Object.groupBy(res, ({ answerGroupName }) => answerGroupName);
                    this.selectedArray = res;
                    this.loadingSelected = false;
                })
                .catch((error) => {
                    if(error) {
                        // console.log(error);
                    }
                })
        }
    },
    created() {
        this.getSections(this.$route.query.diaTestId)
            .then(() => {
                this.changeViewPage('Назначение лабораторных исследований');
                this.checkingFirstStep();

                if(this.getFirstStepOrNot) {
                    this.introJS.setOptions({
                        steps: [
                            {
                                element: document.querySelector('.intro-info'),
                                intro: 'Обратите внимание на показатели пациента!',
                                position: 'bottom'
                            }
                        ]
                    }).start();
                }
            });

        this.getLabResearchesForProcess({ processId: this.$route.params.id, gender: this.$route.query.gender, age: this.$route.query.age });
        this.getSelectedLabResearch();
    }
}
</script>

<style>
    .v-tooltip__content.menuable__content__active, .custom-tooltip {
        background: #717BF9 !important;
        opacity: 1 !important;
    }

    .info-tooltip  {
        width: 172px;
        height: 80px;
        padding: 8px;
        gap: 10px;
    }
</style>
